import React, { useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  Button,
  Paper,
  Divider
} from "@mui/material";
import { FaPlusSquare } from "react-icons/fa";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

const AddonSection = ({ onAddAddon, onRemoveAddon, addedAddons, t }) => {
  const [addonName, setAddonName] = useState("");
  const [addonPrice, setAddonPrice] = useState("");
  const [addonDiscount, setAddonDiscount] = useState("0");
  const [addonQuantity, setAddonQuantity] = useState(1);

  const incrementAddon = () => setAddonQuantity((prev) => prev + 1);
  const decrementAddon = () => {
    if (addonQuantity > 1) setAddonQuantity((prev) => prev - 1);
  };

  const handleAddAddon = () => {
    if (!addonName || !addonPrice) return;
    const newAddon = {
      item: addonName,
      price: Number(addonPrice),
      discount: Number(addonDiscount),
      number: addonQuantity,
      quantity: addonQuantity,
    };
    onAddAddon(newAddon);
    setAddonName("");
    setAddonPrice("");
    setAddonDiscount("0");
    setAddonQuantity(1);
  };

  const handleRemoveAddon = (indexToRemove) => {
    if (onRemoveAddon) onRemoveAddon(indexToRemove);
  };

  return (
    <Box mt={4} className="space-y-6">
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t("admin:addonName")}
            value={addonName}
            onChange={(e) => setAddonName(e.target.value)}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label={t("addProductPage:priceLabel")}
            type="number"
            value={addonPrice}
            onChange={(e) => setAddonPrice(e.target.value)}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label={t("admin:discount")}
            type="number"
            value={addonDiscount}
            onChange={(e) => setAddonDiscount(e.target.value)}
            variant="outlined"
            size="small"
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            label={t("admin:quantity")}
            type="number"
            value={addonQuantity}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton onClick={decrementAddon} size="small">
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={incrementAddon} size="small">
                    <AddIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }}
            variant="outlined"
            size="small"
          />
        </Grid>
      </Grid>

      <Box mt={4} display="flex" justifyContent="center">
        <Button
          variant="outlined"
          onClick={handleAddAddon}
          startIcon={<FaPlusSquare />}
        >
          {t("admin:addItem") || "Add Additional Item"}
        </Button>
      </Box>

      {addedAddons?.length > 0 && (
        <Box mt={4}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            {t("admin:addonHeader")}
          </Typography>
          {addedAddons.map((addon, index) => (
            <Paper
              key={index}
              variant="outlined"
              sx={{ p: 2, mb: 2, position: "relative" }}
            >
              <IconButton
                onClick={() => handleRemoveAddon(index)}
                size="small"
                sx={{ position: "absolute", top: 8, right: 8 }}
                aria-label="Remove addon"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
              <Typography variant="body2">
                <strong>{addon.item}</strong>
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Grid container spacing={1}>
                <Grid item xs={6} sm={3}>
                  <Typography variant="body2">Price: {addon.price} kr</Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography variant="body2">Discount: {addon.discount}%</Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography variant="body2">Quantity: {addon.quantity}</Typography>
                </Grid>
              </Grid>
            </Paper>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default AddonSection;
